import { render, staticRenderFns } from "./OthersContact.vue?vue&type=template&id=2527785a&scoped=true&"
import script from "./OthersContact.vue?vue&type=script&lang=js&"
export * from "./OthersContact.vue?vue&type=script&lang=js&"
import style0 from "./OthersContact.vue?vue&type=style&index=0&id=2527785a&lang=scss&scoped=true&"
import style1 from "./OthersContact.vue?vue&type=style&index=1&id=2527785a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527785a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2527785a')) {
      api.createRecord('2527785a', component.options)
    } else {
      api.reload('2527785a', component.options)
    }
    module.hot.accept("./OthersContact.vue?vue&type=template&id=2527785a&scoped=true&", function () {
      api.rerender('2527785a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/edit/OthersContact.vue"
export default component.exports